import { inject, Injectable } from '@angular/core';
import { SadmEntityDisplay } from '@modules/sadm/models/sadm-entity-display';
import { Store } from '@ngrx/store';
import { sadmActions } from '@shared/store/sadm/sadm.actions';
import { sequencesActions } from '@shared/store/sequences/sequences.actions';
import { SadmEntityChangesetPartial } from '../models/sadm-entity-changeset-partial';

@Injectable()
export class SadmGridStoreBridgeService {
  private readonly store = inject(Store);

  load(entities: SadmEntityDisplay[], clientCode: string): void {
    for (const entity of entities) {
      this.store.dispatch(sadmActions.getSadmEntitySuccess({ sadmEntity: entity }));
    }
    const sequences = entities.flatMap((entity) => entity.sequences ?? []).filter((s) => !!s.medias);
    if (sequences.length) {
      this.store.dispatch(sequencesActions.loadSequences({ clientCode, data: sequences }));
    }
  }

  save(partial: SadmEntityChangesetPartial, clientCode: string): void {
    if (!partial.success) {
      return;
    }
    switch (partial.action) {
      case 'creation':
        this.store.dispatch(sadmActions.updateSadmEntitySuccess({ sadmEntity: partial.sadmEntity }));
        break;
      case 'sequence-update':
        this.store.dispatch(sequencesActions.updateSequenceSuccess({ clientCode, updatedSequence: partial.sequence }));
        break;
      case 'sequence-create':
        this.store.dispatch(sequencesActions.createSequenceSuccess({ clientCode, sequence: partial.sequence }));
        break;
      case 'medias-attach':
        this.store.dispatch(
          sequencesActions.attachSequenceMediasSuccess({
            clientCode,
            sequenceId: partial.sequenceId,
            medias: partial.medias,
          }),
        );
        // Attaching medias can change the sadm entity's preview media
        this.store.dispatch(sadmActions.getSadmEntity({ sadmEntityId: partial.sadmEntityId }));
        break;
      case 'media-remove':
        this.store.dispatch(
          sequencesActions.deleteSequenceMediaSuccess({ sequenceId: partial.sequenceId, mediaId: partial.mediaId }),
        );
        break;
    }
  }
}
